import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getHelpsList } from "src/api/request";
import { useAppState } from "src/contexts/AppContext";

const Home = () => {
  const history = useHistory();
  const { state, dispatch } = useAppState();

  useEffect(() => {
    getHelpsList()
      .then((res) => {
        console.log(res);
        dispatch({ type: "HELP_LIST", data: res.data.sort((a, b) => a.software_description > b.software_description ? 1 : -1) });
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card">
      <div className="main-content-body main-content-body-mail card-body">
        <div className="main-mail-header">
          <div>
            <h4
              className="card-title mt-2 mb-1 text-center"
              style={{ textAlign: "center", color: "rgb(137, 92, 209)" }}
            >
              Хэрэглэгчийн гарын авлага
            </h4>
          </div>

          <div>
            <span>1-1 of 1</span>
            <div className="btn-group" role="group">
              <button
                className="btn btn-outline-secondary disabled"
                type="button"
              >
                <i className="icon ion-ios-arrow-back"></i>
              </button>
              <button className="btn btn-outline-secondary" type="button">
                <i className="icon ion-ios-arrow-forward"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="main-mail-list">
          {state.helplist.map((i, idx) => {
            // console.log(i.software_description)
            return (
              <div key={idx} className="main-mail-item">
                <div
                  className="main-mail-body"
                  onClick={(e) => {
                    e.preventDefault();
                    history.push("/help/" + i.software_id);
                  }}
                >
                  <div className="main-mail-from">
                    <strong>{i.software_name}</strong>
                  </div>
                  <div className="main-mail-subject">
                    <span>{i.software_description}</span>
                  </div>
                </div>
              </div>
            );
          })}

          {/* <div className="main-mail-item">
            <div
              className="main-mail-body"
              onClick={(e) => {
                e.preventDefault();
                history.push("/help/2");
              }}
            >
              <div className="main-mail-from">
                <strong>Zoom систем</strong>
              </div>
              <div className="main-mail-subject">
                <span>Гар утсан дээрх тохиргооны гарын авлага</span>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Home);
